import Student from "../../../apis/student/student.js";
export default {
  namespaced: true,

  state() {
    return {
      resources: {
        data: [],
        current_page: 0,
        last_page: 1,
        total: 0,
      },

      keys: {
        resources: {
          localStorageName: "students",
        },
      },

      filters: {
        standard_id: null,
        section_id: null,
      },

      unallocatedResources: null,

      studentsBySectionStandard: [],
    };
  },

  getters: {
    unallocatedResources(state) {
      return state.unallocatedResources;
    },

    resourcesKey(state) {
      return state.keys.resources;
    },

    resources(state) {
      return state.resources;
    },

    filters(state) {
      return state.filters;
    },

    nextResourcesPage(_, getters) {
      const resources = getters.resources;
      const current_page = resources.current_page;
      const last_page = resources.last_page;
      return last_page > current_page ? current_page + 1 : false;
    },

    studentsBySectionStandard(state){
      return state.studentsBySectionStandard;
    },

  },

  mutations: {
    resources(state, payLoad) {
      if (payLoad.refresh) {
        state.resources.data = payLoad.response.data;
      } else {
        state.resources.data.push(...payLoad.response.data);
      }
      state.resources.current_page = payLoad.response.current_page;
      state.resources.last_page = payLoad.response.last_page;
      state.resources.total = payLoad.response.total;
      localStorage.setItem(payLoad.key, JSON.stringify(state.resources));
    },

    filters(state, payLoad) {
      state.filters = payLoad;
    },

    unallocatedResources(state, payLoad) {
      state.unallocatedResources = payLoad;
    },

    studentsBySectionStandard(state, payLoad) {
      state.studentsBySectionStandard = payLoad;
    },
  },

  actions: {
    async resources(context, payLoad) {
      const refresh = payLoad.refresh ? true : false;
      const key = context.getters.resourcesKey;
      const filters = context.getters.filters;
      const inLocalStorage = refresh
        ? null
        : await JSON.parse(localStorage.getItem(key.localStorageName));

      if (inLocalStorage) {
        context.state.resources = inLocalStorage;
      }

      const nextResourcesPage = refresh ? 1 : context.getters.nextResourcesPage;
      const search_string = payLoad.search_string === null ? '' : payLoad.search_string;

      if (nextResourcesPage) {
        //  const response = await ImportedApi.index(page)
        const response = await Student.index(nextResourcesPage, search_string, filters);

        const dispatch = {
          response: response.data,
          refresh: refresh,
          key: key.localStorageName,
        };
        context.commit("resources", dispatch);
      }
    },

    async createResource(context, payLoad) {
      // const response = await ImportedApi.create(resource_id)
      await Student.create(payLoad);
      context.dispatch("resources", { refresh: true });
    },

    async updateResource(context, payLoad) {
      // const response = await ImportedApi.update(resource_id, data)
      const data = payLoad
      await Student.update(payLoad.id, data);
      context.dispatch("resources", { refresh: true });
    },

    // async deleteResource(context, payLoad) {
    //   // const response = await ImportedApi.delete(resource_id)
    //   await Student.delete(payLoad);
    //   context.dispatch("resources", { refresh: true });
    // },

    async studentsBySectionStandard(context, payLoad){
      // All resources without pagination
      const studentsBySectionStandard = await Student.studentsBySectionStandard(payLoad);
      context.commit("studentsBySectionStandard", studentsBySectionStandard.data)
    },

    async unallocatedResources(context) {
      // All resources without pagination
      const unallocatedResources = await Student.unallocated();
      context.commit("unallocatedResources", unallocatedResources.data);
    },

    async filters(context, payLoad) {
      await context.commit("filters", payLoad);
      context.dispatch("resources", { refresh: true });
    },

    async transferStudent(_, payLoad){
      // All resources without pagination
      await Student.transferStudent(payLoad);
    },
  },
};
